import { TOUR_EXPLORE_ERROR, TOUR_EXPLORE_START, TOUR_EXPLORE_SUCCESS } from "../Constant/TourExploreConstant";
import { TOUR_RECOMMENDED_SUCCESS, TOUR_RECOMMENDED_ERROR, TOUR_RECOMMENDED_START } from "../Constant/TourRecommendedConstant";

const initialState = {
    loading: false,
    data: [],
    recommendedData: []
};

export default function TourExploreReducer(
    state = { ...initialState },
    action
) {
    switch (action.type) {
        case TOUR_EXPLORE_START:
            return {
                ...state,
                loading: true,
            };
        case TOUR_EXPLORE_SUCCESS:
            return {
                ...state,
                data: action.payload,
                loading: false,
            };
        case TOUR_EXPLORE_ERROR:
            return {
                ...state,
                loading: false,
                message: action.error.message,
            };
        case TOUR_RECOMMENDED_START:
            return {
                ...state,
                loading: false,
            };
        case TOUR_RECOMMENDED_SUCCESS:
            return {
                ...state,
                recommendedData: action.payload,
                loading: false,
            };
        case TOUR_RECOMMENDED_ERROR:
            return {
                ...state,
                loading: false,
                message: action.error.message,
            };
        default:
            return state;
    }
}
